export function donorsHasErrored(state = false, action) {
    switch (action.type) {
        case 'DONORS_HAS_ERRORED':
            return action.donorsHasErrored;

        default:
            return state;
    }
}

export function donorsIsLoading(state = false, action) {
    switch (action.type) {
        case 'DONORS_IS_LOADING':
            return action.donorsIsLoading;

        default:
            return state;
    }
}

export function donors(state = {}, action) {
    switch (action.type) {
        case 'DONORS_FETCH_SUCCESS':
            return action.donors;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/donors.js